<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="image0"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><img alt="" src="images/half.jpg" style="width:100%"/><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253054708_Halftitle2.vue?45369596